module.exports = __webpack_public_path__ + "static/media/S3N12-6.80bb9e1c.svg";